import { ref, watch, onMounted, onBeforeUnmount, Ref } from 'vue'
import { emitter } from '../eventBus'

const collapseStateMap = new Map<string, Ref<boolean>>()

export function useSharedCollapse(id: string) {
  if (!collapseStateMap.has(id)) {
    collapseStateMap.set(id, ref(false))
  }
  const showCollapse = collapseStateMap.get(id)!

  function onCollapseShown({ id: emittedId }: { id: string }): void {
    if (emittedId !== id) showCollapse.value = false
  }

  onMounted(() => {
    emitter.on('collapse-shown', onCollapseShown)
  })

  onBeforeUnmount(() => {
    emitter.off('collapse-shown', onCollapseShown)
  })

  watch(showCollapse, (val: boolean) => {
    if (val) emitter.emit('collapse-shown', { id })
  })

  return { showCollapse }
}
